/** Estados vacíos, de carga y de error. */

import { ApiError } from "../api/client";

export function Loading({ what = "datos" }: { what?: string }) {
  return (
    <div className="state">
      <p>Cargando {what}…</p>
    </div>
  );
}

export function ErrorState({ error, hint }: { error: Error; hint?: string }) {
  const notReady = error instanceof ApiError && error.isNotReady;
  /* Los datos van por detrás del código: se desplegó una versión que consulta
     algo que la última sincronización todavía no cargó. No es un fallo de la
     aplicación y no se arregla reintentando, así que no se anuncia como tal. */
  const atrasado = error instanceof ApiError && error.isSchemaBehind;
  const titulo = atrasado
    ? "Reporte temporalmente no disponible"
    : notReady
      ? "Todavía no hay datos"
      : "No se pudo cargar";
  return (
    <div className="state">
      <h2>{titulo}</h2>
      <p>{error.message}</p>
      {atrasado && (
        <p className="muted small">
          Se resuelve con una sincronización. El resto de los reportes sigue
          disponible.
        </p>
      )}
      {hint && !atrasado && <p className="muted small">{hint}</p>}
    </div>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return (
    <div className="state">
      <p>{children}</p>
    </div>
  );
}
